import {
    ListingCategory,
    ListingData,
    ListingUris,
    Transport
} from 'graphql.generated';

export const getNearestTransport = (
    transports: Array<Transport | null | undefined> | null | undefined
): Transport | null => {
    if (!transports?.length) return null;

    const filteredTransports = transports.filter(
        (transport) => !!transport?.distanceInMiles
    ) as Array<Transport>;

    const sortedTransports = [...filteredTransports].sort(
        (a, b) => a.distanceInMiles! - b.distanceInMiles!
    );

    return sortedTransports[0] || null;
};

type GetContactLinkInputProps = Pick<ListingData, 'category' | 'section'> & {
    listingUris: Pick<ListingUris, 'contact'>;
};

export const getContactLink = ({
    category,
    listingUris: { contact },
    section
}: GetContactLinkInputProps): string => {
    if (!section || category !== ListingCategory.Residential) {
        return contact || '';
    }
    if (section && ['to-rent', 'for-sale', 'new-homes'].includes(section)) {
        return contact?.replace('contact', 'details/contact') || '';
    }
    return contact || '';
};
